<template>
  <div class="m-container">
    <m_header></m_header>
    <m_menu></m_menu>
    <div class="m-body">
      <el-container class="m-title-box">
        <div class="m-title">
          <div class="m-title-t">热门报告</div>
          <span class="m-title-s">对热门报告操作</span>
        </div>
        <div class="m-tips">
          <i class="el-icon-warning"></i>使用提示
        </div>
      </el-container>
      <div class="m-table">
        <el-container class="m-table-head">
          <div class="m-article-box">
            <div v-for="(item, index) in dataListOpt" :key="index" :index="index" class="m-article-item"
                 :class="item['id'] === form.parentId ? 'm-article-selected' : ''"
                 v-if="item['title'] === '商业眼光' || item['title'] === '专业创业' || item['title'] === '创业防守'"
                 @click="listData(item['id'])">
              <div>{{ item['title'] }}</div>
            </div>
          </div>
          <div class="m-table-btn">
<!--            <el-button @click="openPopup" type="primary">新增排行</el-button>-->
          </div>
        </el-container>
        <el-table :data="list" v-loading="isLoading" style="width: 100%;margin-bottom: 20px;" border size="small">
          <el-table-column prop="title" label="标题" width=""></el-table-column>
          <el-table-column prop="sort" label="排序" width="300">
            <template slot-scope="scope">
              <div style="display: flex;align-items: center;width: 100%;">
<!--                <div style="width: 20%">{{ scope.row.sort }}</div>-->
                <div style="width: 55%">
<!--                  <el-input placeholder="输入修改排序" size="mini" style="width: 100px;" v-model=""></el-input>-->
                  <el-input-number size="mini" v-model="scope.row.sort" :precision="0"></el-input-number>
                </div>
                <div style="width: 30%">
                  <el-button type="primary" size="mini" @click="submitSort(scope.row.id, scope.row.sort)" plain>提交</el-button>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="updateDate" label="修改时间" align="center"></el-table-column>
          <el-table-column label="操作" width="200" align="center">
            <template slot-scope="scope">
              <el-button type="danger" size="mini" @click="openPopup(scope.row)" plain>修改上榜</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="修改上榜" :visible.sync="openState" @close='closeDialog' width="650px" center :close-on-click-modal="false">
      <div class="m-open-container">
        <div class="zs-open-body-ov">
          <el-form :model="form" :rules="rules" ref="form" label-width="125px">
            <el-form-item label="所属栏目: " prop="removeArticleId">
              <div class="m-article-box">
                <div v-for="(item, index) in dataListOpt" :key="index" :index="index" class="m-article-open-item"
                     :class="item['id'] === form.parentId ? 'm-article-selected' : ''"
                     v-if="item['title'] === '商业眼光' || item['title'] === '专业创业' || item['title'] === '创业防守'">
                  <div>{{ item['title'] }}</div>
                </div>
              </div>
            </el-form-item>
            <el-form-item label="当前榜位报告: ">
              <div style="font-weight: bold;font-size: 16px">{{ form.title }}</div>
            </el-form-item>
            <el-form-item label="选择上榜报告: ">
              <el-input v-model="selectedTitle" placeholder="点击右侧按钮" disabled>
                <el-button type="primary" slot="append"  @click="openArticleOption()">选择报告</el-button>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-foote" style="text-align: center;" v-loading="formLoading">
          <el-button @click="openState = false">取 消</el-button>
          <el-button type="primary" @click="submit()">确 定</el-button>
        </div>
      </div>
      <!-- 选择树 -->
      <el-dialog width="600px" title="请选择上级菜单" :visible.sync="tree" @close="filterText = ''" center append-to-body>
        <div v-loading="optionsLoading">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
          <el-tree
            class="filter-tree"
            :data="articleList"
            :props="defaultProps"
            node-key="id"
            default-expand-all
            :filter-node-method="filterNode"
            ref="tree">
          <span class="custom-tree-node" slot-scope="{ node, data }">
            <span>{{ node.label }}</span>
            <span>
              <el-button type="text" size="mini" :name="node.label" :value="data.id" @click="selectMenu">选择</el-button>
            </span>
          </span>
          </el-tree>
        </div>
      </el-dialog>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'articleHot',
  data () {
    return {
      openText: '编辑',
      openState: false,
      formLoading: false,
      isLoading: true,
      optionsLoading: true,
      selectedTitle: '',
      list: [],
      articleList: [],
      sortInfo: {},
      form: {
        parentId: '',
        id: '',
        sort: '',
        articleId: '',
        title: ''
      },
      tree: false,
      filterText: '',
      dataListOpt: [],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      rules: {
        selectedTitle: [
          { required: true, message: '请选择上榜报告', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val)
    }
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data.title.indexOf(value) !== -1
    },
    selectMenu (e) {
      for (let i = 0; i < this.list.length; i++) {
        if (e.target.parentElement.value === this.list[i].articleId) {
          return this.$message.error('当前报告已在榜单中，请选择其它报告。')
        }
      }
      this.tree = false
      this.selectedTitle = e.target.parentElement.name
      this.form.articleId = e.target.parentElement.value
    },
    closeDialog: function () {
      this.form = {
        parentId: this.form.parentId,
        id: '',
        sort: '',
        articleId: '',
        title: ''
      }
      this.selectedTitle = ''
      this.openText = '修改榜单'
      this.openState = false
      this.formLoading = false
    },
    openPopup (row) {
      this.form = {
        parentId: this.form.parentId,
        id: row.id,
        sort: row.sort,
        articleId: '',
        title: row.title
      }
      this.openState = true
    },
    submitSort (id, sort) {
      let _this = this
      if (sort < 1) {
        _this.$message.error('输入大于1的数字')
        return
      }
      this.$confirm('您确定要修改排序吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post('/hot/updateSort', {id: id, sort: sort})
          .then((res) => {
            if (res.status === 200) {
              _this.$message.success(res.msg)
              _this.listData(_this.form.parentId)
            } else {
              _this.$message.error(res.msg)
            }
          })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    submit () {
      let _this = this
      if (_this.form.articleId === '') {
        _this.$message.error('请选择要替换的报告')
        return
      }
      _this.formLoading = true
      this.$axios.post('/hot/updateHot', _this.form)
        .then((res) => {
          if (res.status === 200) {
            _this.$message.success(res.msg)
            _this.openState = false
            _this.listData(_this.form.parentId)
          } else {
            _this.$message.error(res.msg)
          }
          _this.formLoading = false
        })
    },
    openArticleOption () {
      let _this = this
      _this.tree = true
      _this.optionsLoading = true
      this.$axios.post('/article/list', {homeOptionId: _this.form.parentId})
        .then((res) => {
          _this.articleList = res.data
          _this.optionsLoading = false
        })
    },
    // 报告列表
    loadArticleList () {
      let _this = this
      this.$axios.post('/article/list')
        .then((res) => {
          _this.dataListOpt = res.data
        })
    },
    // 获取栏目列表，默认选中第0个栏目
    homeOptionData () {
      let _this = this
      _this.dataListOpt = []
      this.$axios.post('/appHome/list')
        .then((res) => {
          _this.dataListOpt = res.data
          if (_this.dataListOpt.length > 0) {
            _this.listData(res.data[0].id)
          }
        })
    },
    // 列表
    listData (parentId) {
      let _this = this
      _this.form.parentId = parentId
      _this.isLoading = true
      _this.list = []
      this.$axios.post('/hot/list', {parentId: _this.form.parentId})
        .then((res) => {
          _this.list = res.data
          _this.isLoading = false
        })
    }
  },
  mounted () {
    this.homeOptionData()
    // this.loadArticleList()
  }
}
</script>

<style scoped src="../../assets/css/article.css"></style>



// WEBPACK FOOTER //
// src/components/article/ArticleHot.vue